import * as API from '../api'
import { generate_timestamp } from '../utils/timestamp'

export const FETCHING_CERTIFICATE_CONTROLS = 'FETCHING_CERTIFICATE_CONTROLS'
export const FETCH_CERTIFICATE_CONTROLS = 'FETCH_CERTIFICATE_CONTROLS'
export const FETCH_CERTIFICATE_CONTROLS_ERROR = 'FETCH_CERTIFICATE_CONTROLS_ERROR'

export const FETCHING_DOWNLOAD_XLS = 'FETCHING_DOWNLOAD_XLS'
export const FETCH_DOWNLOAD_XLS = 'FETCH_DOWNLOAD_XLS'
export const FETCH_DOWNLOAD_XLS_ERROR = 'FETCH_DOWNLOAD_XLS_ERROR'

export const fetchCertificateControls = (areaId, page, rowsPerPage, orderBy, order) => {
  return dispatch => {
    dispatch({
      type: FETCHING_CERTIFICATE_CONTROLS,
      value: true
    })

    return API.certificateControls
      .getCertificateControls(areaId, page, rowsPerPage, orderBy, order)
      .then(response => {
        const { data = {} } = response
        const { items, last_update, total_records, pagination } = data

        dispatch({
          type: FETCH_CERTIFICATE_CONTROLS,
          items,
          last_update,
          total_records,
          pagination
        })
      })
      .catch(err => {
        dispatch({
          type: FETCH_CERTIFICATE_CONTROLS_ERROR
        })
      })
  }
}

export const fetchSearch = (areaId, page, rowsPerPage, orderBy, order) => {
  return dispatch => {
    dispatch({
      type: FETCHING_CERTIFICATE_CONTROLS,
      value: true
    })

    return API.certificateControls
      .getSearchCertificateControls(areaId, page, rowsPerPage, orderBy, order)
      .then(response => {
        const { data = {} } = response
        const { items, last_update, total_records, pagination } = data

        dispatch({
          type: FETCH_CERTIFICATE_CONTROLS,
          items,
          last_update,
          total_records,
          pagination
        })
      })
      .catch(err => {
        dispatch({
          type: FETCH_CERTIFICATE_CONTROLS_ERROR
        })
      })
  }
}

export const fetchDownloadXls = (searchText, areaId) => {
  return dispatch => {
    dispatch({
      type: FETCHING_DOWNLOAD_XLS
    })

    return API.certificateControls
      .downloadXls(searchText, areaId)
      .then(response => {

        const filename = 'Controle de certificados ' + generate_timestamp() + '.xlsx'

        const blob = new Blob([response.data], {
          type: 'application/xlsx',
          charset: 'UTF-8'
        })

        const createLink = () => {
          const link = document.createElement('a')

          if (link.download !== undefined) {
            const url = window.URL.createObjectURL(blob)

            link.setAttribute('href', url)
            link.setAttribute('download', filename)

            link.style = 'visibility: hidden'

            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          }
        }

        dispatch({
          type: FETCH_DOWNLOAD_XLS
        })

        return (navigator.msSaveBlob && navigator.msSaveBlob(blob, filename)) || createLink()
      })
      .catch(err => {
        dispatch({
          type: FETCH_DOWNLOAD_XLS_ERROR
        })
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/certificateControl.js